var routeHmrEpoch = 0;
var routeHmrListeners = /* @__PURE__ */ new Set();
var subscribeRouteHmr = function subscribeRouteHmr2(onStoreChange) {
  routeHmrListeners.add(onStoreChange);
  return function() {
    routeHmrListeners.delete(onStoreChange);
  };
};
var getRouteHmrEpoch = function getRouteHmrEpoch2() {
  return routeHmrEpoch;
};
if (process.env.NODE_ENV === "development") {
  globalThis.__VXRN_ON_MODULE_UPDATED__ = function(id) {
    try {
      var routeCache = typeof window === "undefined" ? void 0 : window.__oneRouteCache;
      if (typeof (routeCache === null || routeCache === void 0 ? void 0 : routeCache.clearFile) === "function") {
        routeCache.clearFile(id);
      }
    } catch (error) {
      console.error("[one] route cache eviction failed", error);
    }
  };
}
export {
  getRouteHmrEpoch,
  subscribeRouteHmr
};
//# sourceMappingURL=routeHmr.native.js.map
